import { Row } from 'antd';

import { PlumbingProduct } from '@common/models';
import { COMING_SOON_IMAGE, getProductDescription } from '@common/utils';
import { formatPriceUnitOrFree } from '@common/utils/formatPriceUnitOrFree';
import ProductCard from '@core/components/ProductCard/ProductCard';
import QuantitySelector from '@core/components/QuantitySelector/QuantitySelector';
import ImageUtils from '@core/utils/ImageUtils';

interface PlumbingItemProps {
    product: PlumbingProduct;
    isSelected?: boolean;
    quantity?: number;
    changeQuantity: (product: PlumbingProduct, amount: number) => void;
    updateQuantity: (product: PlumbingProduct, newQuantity: number) => void;
    onClick: () => void;
}

export const PlumbingItem = ({
    product,
    isSelected = false,
    quantity = 0,
    updateQuantity,
    onClick,
}: PlumbingItemProps): JSX.Element => {
    const imgSrc = product.imageUrl ? ImageUtils.imgUrl(product.imageUrl, 300) : COMING_SOON_IMAGE;

    return (
        <ProductCard isSelected={isSelected} onClick={onClick} additionalClasses={{ 'multi-action-card': true }}>
            <ProductCard.Image src={imgSrc} />
            <ProductCard.Title>{getProductDescription(product)}</ProductCard.Title>
            <ProductCard.Subtitle>{formatPriceUnitOrFree(product.price, product.unitOfMeasure)}</ProductCard.Subtitle>
            {isSelected && (
                <Row justify={'center'}>
                    <QuantitySelector
                        value={quantity}
                        min={0}
                        unitOfMeasure={product.unitOfMeasure}
                        onValueChange={(value) => {
                            updateQuantity(product, value);
                        }}
                    />
                </Row>
            )}
        </ProductCard>
    );
};
